var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0E8080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5H17.5V16.5H10.5V17.5ZM10.5 14.5H21.5V13.5H10.5V14.5ZM10.5 11.5H21.5V10.5H10.5V11.5ZM7 24.077V8.615C7 8.155 7.15433 7.771 7.463 7.463C7.771 7.15433 8.155 7 8.615 7H23.385C23.845 7 24.229 7.15433 24.537 7.463C24.8457 7.771 25 8.155 25 8.615V19.385C25 19.845 24.846 20.2293 24.538 20.538C24.2293 20.846 23.845 21 23.385 21H10.077L7 24.077ZM9.65 20H23.385C23.5383 20 23.6793 19.936 23.808 19.808C23.936 19.6793 24 19.5383 24 19.385V8.615C24 8.46167 23.936 8.32067 23.808 8.192C23.6793 8.064 23.5383 8 23.385 8H8.615C8.46167 8 8.32067 8.064 8.192 8.192C8.064 8.32067 8 8.46167 8 8.615V21.645L9.65 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicateIcon);
export default __webpack_public_path__ + "static/media/communicateIcon.6cb3c82d8e661abd98224e18da814bef.svg";
export { ForwardRef as ReactComponent };